import { ABNORMALITIES, RECOVERY_ACTIONS, ROLES } from '../../constants';

export const determineRequiredRoleForAbnormalityType = (recActionType, action) => {
    switch (recActionType) {
        case ABNORMALITIES.BLOWOUT:
            return ROLES[`ABNORMALITY_BLOWOUT_${action}`];
        case ABNORMALITIES.DELAY:
            return ROLES[`ABNORMALITY_DELAY_${action}`];
        case ABNORMALITIES.DAMAGE:
        case ABNORMALITIES.EARLY_FREIGHT:
        case ABNORMALITIES.GENERIC:
        case ABNORMALITIES.INTERNAL_LOGISTICS:
        case ABNORMALITIES.LATE_FREIGHT:
        case ABNORMALITIES.NEW_ORDER:
        case ABNORMALITIES.RETURN_FREIGHT:
        case ABNORMALITIES.SHORT_SHIPMENT:
        case ABNORMALITIES.PARTIAL_SHORT_SHIPMENT:
        case ABNORMALITIES.UNABLE_TO_LOCATE:
            return ROLES[`ABNORMALITY_GENERIC_${action}`];
        case ABNORMALITIES.MISCOLLECTION:
            return ROLES[`ABNORMALITY_MISCOLLECTION_${action}`];
        default:
            console.error(
                `[RoleDeterminator] No role found for type ${recActionType}, missing in constants?`
            );
            return null;
    }
};

export const determineRequiredRoleForRecoveryActionType = (recActionType, action) => {
    switch (recActionType) {
        case RECOVERY_ACTIONS.INSERT_MANIFEST:
            return ROLES[`RECOVERY_ACTION_INSERT_MANIFEST_${action}`];
        case RECOVERY_ACTIONS.PULL_FORWARD:
            return ROLES[`RECOVERY_ACTION_PULL_FORWARD_${action}`];
        case RECOVERY_ACTIONS.SLIDE:
            return ROLES[`RECOVERY_ACTION_SLIDE_${action}`];
        case RECOVERY_ACTIONS.SPECIAL:
            return ROLES[`RECOVERY_ACTION_SPECIAL_${action}`];
        case RECOVERY_ACTIONS.TAP:
            return ROLES[`RECOVERY_ACTION_TAP_${action}`];
        default:
            console.error(
                `[RoleDeterminator] No role found for type ${recActionType}, missing in constants?`
            );
            return null;
    }
};
